<template>
  <v-card class="mb-4" elevation="2" v-if="shirtsEnabled">
    <v-card-title>
      <v-checkbox
          :input-value="wantShirts"
          @change="$emit('update:wantShirts', $event)"
          label="Wir wollen T-Shirts bestellen (15€ pro Shirt)"
          hide-details
          class="mt-0"
      ></v-checkbox>
      <v-spacer></v-spacer>
      <v-dialog width="340px" v-model="showShirtCarousel">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="brown"
              outlined
              small
              v-bind="attrs"
              v-on="on"
          >Größentabelle
          </v-btn>
        </template>
        <v-card>
          <v-carousel show-arrows>
            <v-carousel-item>
              <v-card>
                <v-card-title>Shirt</v-card-title>
                <v-img src="/shirt.png"></v-img>
              </v-card>
            </v-carousel-item>
            <v-carousel-item>
              <v-card>
                <v-card-title>Stanley/Stella, Gerade</v-card-title>
                <v-simple-table>
                  <thead>
                  <tr>
                    <th>Größe</th>
                    <th>Länge</th>
                    <th>Breite</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr><td>S</td><td>68</td><td>48</td></tr>
                  <tr><td>M</td><td>72</td><td>52</td></tr>
                  <tr><td>L</td><td>74</td><td>55</td></tr>
                  <tr><td>XL</td><td>76</td><td>58</td></tr>
                  <tr><td>XXL</td><td>78</td><td>62</td></tr>
                  <tr><td>3XL</td><td>80</td><td>66</td></tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-carousel-item>
            <v-carousel-item>
              <v-card>
                <v-card-title>Stanley/Stella, Tailliert</v-card-title>
                <v-simple-table>
                  <thead>
                  <tr>
                    <th>Größe</th>
                    <th>Länge</th>
                    <th>Breite</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr><td>XS</td><td>59</td><td>41,5</td></tr>
                  <tr><td>S</td><td>62</td><td>44,5</td></tr>
                  <tr><td>M</td><td>64</td><td>47,5</td></tr>
                  <tr><td>L</td><td>66</td><td>50,5</td></tr>
                  <tr><td>XL</td><td>68</td><td>53,5</td></tr>
                  <tr><td>XXL</td><td>70</td><td>57,5</td></tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-carousel-item>
          </v-carousel>
          <v-card-actions>
            GOTS zertifiziert & Vegan
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showShirtCarousel = false">Schliessen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>

    <v-card-text v-if="wantShirts">
      <v-btn color="primary" small @click="addShirt" class="mb-3">
        <v-icon left>mdi-plus</v-icon>
        Shirt hinzufügen
      </v-btn>

      <v-row v-for="(shirt, index) in shirts" :key="'shirt-' + index" align="center">
        <v-col cols="5">
          <v-select
              :value="shirt.model"
              @input="updateShirtModel(index, $event)"
              :items="shirtModels"
              label="Model"
              :rules="shirtRules"
              required
              dense
          ></v-select>
        </v-col>
        <v-col cols="5">
          <v-select
              :value="shirt.size"
              @input="updateShirtSize(index, $event)"
              :items="getShirtSizes(shirt.model)"
              label="Größe"
              :rules="shirtRules"
              no-data-text="Wähle erst das Model"
              required
              dense
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-btn icon color="error" @click="removeShirt(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Shipping Fee (only when shirts ordered) -->
      <v-divider class="my-4"></v-divider>
      <h3>Versand</h3>
      <v-row>
        <v-col cols="6">
          <v-select
              :value="packageFee"
              @input="onPackageFeeChange"
              :items="packageFeeItems"
              item-text="name"
              item-value="amount"
              return-object
              label="Versand"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ShirtsCard',
  props: {
    wantShirts: {
      type: Boolean,
      default: false
    },
    shirts: {
      type: Array,
      default: () => []
    },
    packageFee: {
      type: Object,
      required: true
    },
    packageFeeItems: {
      type: Array,
      required: true
    },
    shirtsEnabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showShirtCarousel: false,
    shirtModels: ['Tailliert', 'Gerade'],
    shirtSizesTailliert: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    shirtSizesUnisex: ['S', 'M', 'L', 'XL', 'XXL', '3XL']
  }),
  computed: {
    shirtRules() {
      const rules = [];
      if (this.wantShirts && this.shirts.length > 0) {
        rules.push(v => !!v || 'Pflichtfeld für Shirt-Bestellung');
      }
      return rules;
    }
  },
  methods: {
    addShirt() {
      const newShirts = [...this.shirts, { model: '', size: '' }];
      this.$emit('update:shirts', newShirts);
    },
    removeShirt(index) {
      const newShirts = this.shirts.filter((_, i) => i !== index);
      this.$emit('update:shirts', newShirts);
    },
    updateShirtModel(index, value) {
      const newShirts = [...this.shirts];
      newShirts[index] = { ...newShirts[index], model: value, size: '' };
      this.$emit('update:shirts', newShirts);
    },
    updateShirtSize(index, value) {
      const newShirts = [...this.shirts];
      newShirts[index] = { ...newShirts[index], size: value };
      this.$emit('update:shirts', newShirts);
    },
    getShirtSizes(model) {
      if (model === 'Tailliert') {
        return this.shirtSizesTailliert;
      } else if (model === 'Gerade') {
        return this.shirtSizesUnisex;
      }
      return [];
    },
    onPackageFeeChange(value) {
      this.$emit('update:packageFee', value);
      this.$emit('packageFeeChanged', value);
    }
  }
}
</script>
